import { useApiReadyQuery } from 'api/hooks/helpers/useApiReadyQuery'
import { QueryOptions } from 'api/hooks/helpers/useApiQuery'
import { cacheKeys } from 'api/cacheKeys'
import { User } from 'api/domain/user'
import { useAppApi } from 'api/providers/AppApiProvider'
import { ProfileApi } from 'api/APIs/ProfileApi'
import { useUpdateQuery } from 'api/hooks/helpers/useUpdateQuery'

export function useMyProfile(options?: QueryOptions<User>) {
  const profileApi = useAppApi(ProfileApi)

  const updateUser = useUpdateQuery(cacheKeys.myProfile)
  const query = useApiReadyQuery<User>(cacheKeys.myProfile, () => profileApi.me(), {
    ...options,
  })

  return { updateUser, ...query }
}
